import BaseApiService from '@/services/BaseApiService';
import WebEnvConfig from '@/models/WebEnvConfig';
import IManualComp from '@/models/comp/IManualComp';
import ICompAddress from '@/models/CompAddress';
import IServiceHelper from './IServiceHelper';
import ServiceHelperFactory from './ServiceHelperFactory';
import IFormFillerData from '@/models/comp/IFormFillerData';

export default class DataDiscrepancyService extends BaseApiService {
        private readonly currentHostname: string;

    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
        this.currentHostname = String(webEnvConfig.hostname || '').toLowerCase();
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getCompAddresses(almCompId: string): Promise<IFormFillerData> {
        let result: IFormFillerData = { TotalComps: [], RowVisibilityGrid: {} };
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        const data = JSON.stringify(almCompId);

        const response = await this.axiosInstance.post('v7/DataDiscrepancy/CompAddressAndFormFillerData', data);
        if (response.data) {
            result = {
                TotalComps: response.data?.TotalComps ?? [],
                RowVisibilityGrid: response.data?.RowVisibility ?? {},
            };
        }
        return result;
    }

    async getMLSToken(): Promise<string | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const response = await this.axiosInstance.get('v1.0/DataDiscrepancy/MlsMapperToken');
            if (response.status === 200) {
                const result: string = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            console.log(`DataDiscrepancyService.getMLSToken(), Error[${errorDescription}]`);
        }
        return null;
    }

    async scrubAddress(payload: IManualComp): Promise<ICompAddress> {
        let result = {};
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();

        const data = JSON.stringify(payload);
        const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/ScrubAddress', data);
        if (response.data) {
            result = response.data;
        }
        return result as ICompAddress;
    }

    // async getDBSourceData(request: LocalCompRequest): Promise<any | null> {
    //     this.addContentTypeJsonHeader();
    //     this.addAcceptJsonHeader();
    //     //this.setLogRequest(true);

    //     try {
    //         const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/LocalBestComp', request);
            
    //         // This is a check to see if we should load fake data for testing purposes.  
    //         // Only localhost and dev environments are allowed to load fake data.
    //         if (
    //             isFakeDataHostnameAllowed(this.currentHostname) &&
    //             theLocalStorageUtils.hasKey('load-fake-data') &&
    //             theLocalStorageUtils.get('load-fake-data')
    //         ) {
    //             if(request.isSubject) {
    //                 return _FakePayload.loadFakeData(SourceDataInitials.Database, true);
    //             } else {
    //                 return _FakePayload.loadFakeData(SourceDataInitials.Database, false);
    //             }
    //         } else {
    //             if (response.data) {
    //                 if (response.status === 200) {
    //                     return response.data;
    //                 }
    //             } else {
    //                 throw new Error(`DataDiscrepancyService.getBestgetDBSourceDataComp(), No data returned from endpoint for address[${CompAddressUtils.getDescription(request.address)}], isSubject[${request.isSubject}], formCode[${request.formCode}]`);
    //             }
    //         }
            
    //     } catch (error) {
    //         const errorDescription = this.getErrorDescription(error);
    //         const addressDescription = CompAddressUtils.getDescription(request.address);
    //         console.log(`DataDiscrepancyService.getDBSourceData(), Error[${errorDescription}] on address[${addressDescription}], isSubject[${request.isSubject}], formCode[${request.formCode}]`);
    //     }

    //     return null;

    // }

    // async getDBSubComps(localCompRequest: LocalCompRequest): Promise<IFeedData[] | null> {
    //     this.addContentTypeJsonHeader();
    //     this.addAcceptJsonHeader();
    //     //this.setLogRequest(true);

    //     try {
    //         const data = JSON.stringify(localCompRequest);

    //         const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/LocalComps', data);
    //         if (response.status === 200) {
    //             const result: IFeedData[] = response.data;
    //             return result;
    //         }
    //     } catch (error) {
    //         const errorDescription = this.getErrorDescription(error);
    //         const addressDescription = CompAddressUtils.getDescription(localCompRequest.address);
    //         console.log(`DataDiscrepancyService.getDBSubComps(), Error[${errorDescription}] on address[${addressDescription}], comps Guid[${localCompRequest.compsGuid}]`);
    //     }
    //     return null;
    // }
}
